<template>
    <ul class="record5Info-box">
        <li class="title-part">
            <div>
                <span class="title-span">{{recordObj.addinfo2}}</span>
            </div>

            <div>
                <el-button type="primary" size="small" @click="clickEdit"><font-awesome-icon icon="fa-solid fa-pen-to-square" /></el-button>
                <el-button type="danger" size="small" @click="clickDelete"><font-awesome-icon icon="fa-solid fa-trash-can" /></el-button>
            </div>
        </li>

        <li>
            <span class="title-text">{{recordObj.addinfo1}}</span>
        </li>

        <li>
            <span class="content-text">{{recordObj.addremark1}}</span>
        </li>

        <li v-if="null != recordObj.fileformatList && recordObj.fileformatList.length > 0">
            <div class="img-part">
                <div class="img-box" v-for="(v, i) in recordObj.fileformatList" :key="i + new Date().getTime()">
                    <img :src="staticPath + v.filename">
                </div>
            </div>
        </li>
    </ul>
</template>

<script setup>
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faTrashCan, faPenToSquare } from '@fortawesome/free-solid-svg-icons'
    import {getCurrentInstance} from "vue";

    const { proxy } = getCurrentInstance();
    library.add(faTrashCan, faPenToSquare)

    const props = defineProps(["recordObj"])
    const emits = defineEmits(["clickEdit", "clickDelete"])

    const staticPath = proxy.$ShopopeeUrl

    function clickEdit() {
        emits("clickEdit", props.recordObj)
    }

    function clickDelete() {
        emits("clickDelete", props.recordObj)
    }

</script>

<style scoped>
    .record5Info-box {
        width: 100%;
        list-style: none;
        padding-left: 0;
        text-align: left;
        padding-bottom: 15px;
    }

    .title-part {
        display: flex;
        justify-content: space-between;
    }

    .record5Info-box li {
        line-height: 1.5;
        word-break: break-all;
    }

    .title-span {
        color: #909399;
        font-size: 14px;
    }

    .title-text {
        color: #303133;
        font-size: 16px;
    }

    .content-text {
        color: #606266;
        font-size: 14px;
    }

    .img-part {
        display: flex;
        width: 100%;
    }

    .img-part .img-box {
        width: 33%;
        padding-top: 30%;
        position: relative;
        box-sizing: border-box;
    }

    .img-part .img-box img {
        width: calc(100% - 10px);
        height: calc(100% - 10px);
        position: absolute;
        object-fit: fill;
        top: 5px;
        left: 5px;
    }
</style>